import { clsx } from 'clsx'
import { ComponentProps, type FC } from 'react'

import logo from '@/assets/images/icon.png'
import { Avatar, AvatarImage } from '@/components'

export type BrandAvatarProps = ComponentProps<typeof Avatar>

export const BrandAvatar: FC<BrandAvatarProps> = ({ className, ...props }) => (
  <Avatar
    accessibilityElementsHidden
    aria-hidden
    className={clsx('border-[0.5px] border-white', className)}
    importantForAccessibility='no-hide-descendants'
    size='sm'
    {...props}
  >
    <AvatarImage
      accessible
      accessibilityLabel='Dateability'
      importantForAccessibility='auto'
      source={logo}
    />
  </Avatar>
)
